import React, { useState } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { useTranslation } from "react-i18next"
// import Dropdown from './Dropdown';

function Navbar() {

  const [traslate, i18n] = useTranslation("navbar");

  const [click, setClick] = useState(false);
  const [dropdown, setDropdown] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const onMouseEnter = () => {
    if (window.innerWidth < 960) {
      setDropdown(false);
    } else {
      setDropdown(true);
    }
  };

  const onMouseLeave = () => {
    if (window.innerWidth < 960) {
      setDropdown(false);
    } else {
      setDropdown(false);
    }
  };

  return (
    <>
      <nav className='navbar'>
        <Link to='/'>
          <div className='firma'>
            <img src={process.env.PUBLIC_URL + '/logotipo.png'} ></img>
          </div>
        </Link>
        <div className='menu-icon' onClick={handleClick}>
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </div>
        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          <li className='nav-item'>
            <Link to='/' className='nav-links' onClick={closeMobileMenu}>
              {traslate("items.item-0")}
            </Link>
          </li>
          <li className='nav-item'>
            <Link
              to='/curriculum'
              className='nav-links'
              onClick={closeMobileMenu}
            >
              {traslate("items.item-1")}
            </Link>
          </li>
          <li className='nav-item'>
            <a
              // to='/galeria-virtual'
              href="http://192.168.1.74:9966/"
              className='nav-links'
              onClick={closeMobileMenu}
            >
              {traslate("items.item-2")}
            </a>
          </li>
          <li className='nav-item '>
            <Link
              to='/obra-disponible'
              className='nav-links '
              onClick={closeMobileMenu}
            >
              {traslate("items.item-4")}
            </Link>
          </li>
          <li className='nav-item'>
            <Link
              to='/contacto'
              className='nav-links'
              onClick={closeMobileMenu}
            >
              {traslate("items.item-5")}
            </Link>
          </li>
          <li>
            <Link
              to='/lenguaje'
              className='nav-links-mobile'
              onClick={closeMobileMenu}
            >
              Languaje
            </Link>
          </li>
        </ul>
        <Button className="btn-lenguaje">
        </Button>
      </nav>
    </>
  );
}

export default Navbar;
